module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-FC-Earthquake.21b1bfc3.gif";